import PartyName from 'components/party/PartyName';
import MatterIndicators from 'components/matters/MatterIndicators';
import { RecordLink } from 'components/record-chip/RecordLink';
import { useIsNewDesign } from 'components/tables/list-table/filter-bar/useIsNewDesign';
import { FC, Fragment } from 'react';
import { FormattedMessage } from 'react-intl';
import { MatterMinWithClientParty } from 'types/matters';
import { cn } from 'utils/cn';

interface Props {
    matter: MatterMinWithClientParty;
    /** Classes for classic's matter link, e.g. a colour it keeps at rest; the new design's chip has its own. */
    linkClassName?: string;
}

const CorrespondenceMatterItem: FC<Props> = ({ matter, linkClassName }) => {
    const isNewDesign = useIsNewDesign();
    return (
        <div>
            <FormattedMessage
                id="correspondence.matter-of-client"
                values={{
                    matter: (
                        <Fragment key="matter">
                            {isNewDesign ? null : (
                                <MatterIndicators isConfidential={matter.isConfidential} className="mr-1" />
                            )}
                            <RecordLink
                                withOrigin
                                className={cn(
                                    'entity-link text-fg hover:text-link no-underline hover:underline',
                                    linkClassName
                                )}
                                to={`/matter/${matter.id}`}
                                label={matter.fullName}
                            />
                        </Fragment>
                    ),
                    client: !matter.clientParty ? (
                        'undefined'
                    ) : (
                        <PartyName
                            key="client"
                            party={matter.clientParty}
                            isLink
                            useLinkWithOrigin
                            variant="readonly-other"
                            showPartyNumber
                        />
                    ),
                }}
            />
            {/* The new design puts the case's chip on a line of its own, under the case and its client. */}
            {isNewDesign ? (
                <MatterIndicators isConfidential={matter.isConfidential} className="mt-1 flex w-fit" />
            ) : null}
        </div>
    );
};

export default CorrespondenceMatterItem;
